// WidgetSeleccionValidacion.js
import React from "react";

const WidgetSeleccionValidacion = (props) => {
  return (
    <div className="chat-options-container">
      <p className="react-chatbot-kit-chat-bot-message">
        ¿Cómo deseas validar la información?
      </p>
      <button
        onClick={() => props.actions.iniciarValidacionRapida()}
        className="chat-option-button"
      >
        Validación rápida
      </button>
      <button
        onClick={() => props.actions.iniciarValidacionConjunto()}
        className="chat-option-button"
      >
        Validación en conjunto
      </button>
    </div>
  );
};

export default WidgetSeleccionValidacion;
